export const skills = [
  {
    type: "UX skills",
    value: [
      "Problem Validation",
      "User Research",
      "Case Study",
      "User Experience Testing",
      "Competitive Analysis",
      "Information Architecture (IA)",
      "Qualitative & Quantitative Research Methodologies",
      "User Journeys",
      "User Story",
      "Card Sorting",
      "User Flow",
      "Task Flow",
      "User Interaction",
      "User Experience Design (UxD)",
      "User Interface Design (UID)",
      "Interaction Design (IxD)",
      "User-centered Design (UCD)",
      "Usability Testing"
    ]
  },
  {
    type: "Tools & Technologies",
    value: [
      "Illustrator",
      "Adobe xD",
      "MS Excell",
      "MS Visio",
      "InVision",
      "Figma",
      "Hotjar",
      "UsailityHub",
      "clickly",
    ]
  },
  {
    type: "Development Skills",
    value: [
      "Node",
      "Express",
      "Vue.js",
      "TypeScript",
      "LESS",
      "OAuth",
      "Agile",
      "Scrum",
      "Web Design",
      "REST",
      "Git"
    ]
  }
];
